import { useAppSelector } from '../../../app/hooks'
import { generateActions } from '../../../shared/utils/actions.utils'

const useDashActions = () => {
  const nearbyPOIs = useAppSelector((state) => state.poi.nearby.data) ?? []

  const actions = generateActions({ pois: nearbyPOIs })

  return { actions }
}

export default useDashActions
